// 航线类型
export enum WaylineType {
  NormalWaypointWayline = 0, // 普通航点航线
  AccurateReshootingWayline = 1 // 精准复拍航线
}

export interface WaylineFile {
  id: string,
  name: string,
  drone_model_key: any,
  payload_model_keys: string[],
  template_types: WaylineType[],
  update_time: number,
  user_name: string,
}
export const CoordinatesType = ['coordinateTurn', 'toPointAndPassWithContinuityCurvature', 'smoothOverPoints']
/** 航线编辑-航点操作 */
export enum WaylineActionType {
  TAKE_PHOTO = 'takePhoto', // 拍照
  START_RECORD = 'startRecord', // 开始录像
  STOP_RECORD = 'stopRecord', // 结束录像
  FOCUS = 'focus', // 聚焦
  ZOOM = 'zoom', // 缩放
  CUSTOM_DIRNAME = 'customDirName', // 自定义文件夹名
  GIMBAL_ROTATE = 'gimbalRotate', // 云台旋转
  GIMBAL_ROTATE_YAW = 'gimbalRotateYaw', // 云台旋转Yaw
  GIMBAL_ROTATE_PITCH = 'gimbalRotatePitch', // 云台旋转Pitch
  ROTATE_YAW = 'rotateYaw', // 旋转Yaw
  HOVER = 'hover', // 悬停
  GIMBAL_EVENLY_ROTATE = 'gimbalEvenlyRotate', // 云台匀速旋转
  ACCURATE_SHOOT = 'accurateShoot', // 精准复拍
  ORIENTED_SHOOT = 'orientedShoot', // 定向复拍
  PANOSHOT = 'panoShot', // 全景拍摄
  MultipleTiming = 'multipleTiming', // 多时段拍摄
  MultipleDistance = 'multipleDistance', // 多距离拍摄
  MultipleEnd = 'multipleEnd', // 多时段多距离拍摄结束
  SET_FOCUS_TYPE = 'setFocusType', // 设置聚焦类型
  SEARCH_LIGHT = 'searchlight', // 闪光灯
  SEARCH_LIGHT_STOP = 'searchlight_stop', // 闪光灯停止
  MEGAPHONE = 'megaphone', // 扩音器
  MEGAPHONE_STOP = 'megaphone_stop', // 扩音器停止
  GIMBAL_ANGLE_LOCK = 'gimbalAngleLock', // 云台角度锁定
  GIMBAL_ANGLE_UNLOCK = 'gimbalAngleUnlock', // 云台角度解锁
  START_TIME_LAPSE = 'startTimeLapse', // 开始延时拍摄
  STOP_TIME_LAPSE = 'stopTimeLapse', // 结束延时拍摄
  START_CONTINUOUS_SHOOTING = 'startContinuousShooting', // 开始连续拍摄
  STOP_CONTINUOUS_SHOOTING = 'stopContinuousShooting', // 结束连续拍摄
  START_AR_RECORD = 'startArRecord', // 开始AR录制
  STOP_AR_RECORD = 'stopArRecord', // 结束AR录制
  START_AI = 'startAI', // 开始AI算法
  STOP_AI = 'stopAI', // 结束AI算法
}

export enum DEVICE_TYPE {
  START_AI= 'startAI',
START_AR_RECORD= 'startArRecord',
START_MP20_LIGHTFLASH= 'startMP20LightFlash',
START_SPEAKER_PLAY= 'startSpeakerPlay',
STOP_AI= 'stopAI',
STOP_AR_RECORD= 'stopArRecord',
STOP_MP20_LIGHTFLASH= 'stopMP20LightFlash',
STOP_SPEAKER_PLAY= 'stopSpeakerPlay'
}
export enum SEQUENCE{
  SEQUENCE= 'sequence'
}
export enum GIMBAL_HEADERING_TYPE{
  AIRCRAFT= 'aircraft',
NORTH='north'
}
export enum GIMBAL_ROTATE_MODE_TYPE{
  ABSOLUTE_ANGLE='absoluteAngle',
RELATIVE_ANGLE= 'relativeAngle'
}
export const PointEnum = {
  BETWEEN_ADJACENT_POINTS: 'betweenAdjacentPoints',
  MULTIPLE_DISTANCE: 'multipleDistance',
  MULTIPLE_TIMING: 'multipleTiming',
  REACH_POINT: 'reachPoint'
}
export const WaylineSmoothType = {
  COORDINATE_TURN: 'coordinateTurn',
  TO_POINT_AND_STOP_WITH_DISCONTINUITY_CURVATURE: 'toPointAndStopWithDiscontinuityCurvature',
  TO_POINT_AND_STOP_WITH_CONTINUITY_CURVATURE: 'toPointAndStopWithContinuityCurvature',
  TO_POINT_AND_PASS_WITH_CONTINUITY_CURVATURE: 'toPointAndPassWithContinuityCurvature',
  SMOOTH_OVER_POINTS: 'smoothOverPoints'
}
export const WAYLINE_SMOOTH_TYPE_NAME = {
  [WaylineSmoothType.COORDINATE_TURN]: '协调转弯，不过点，提前转弯',
  [WaylineSmoothType.TO_POINT_AND_STOP_WITH_DISCONTINUITY_CURVATURE]: '直线飞行，飞行器到点停',
  [WaylineSmoothType.TO_POINT_AND_STOP_WITH_CONTINUITY_CURVATURE]: '曲线飞行，飞行器到点停',
  [WaylineSmoothType.TO_POINT_AND_PASS_WITH_CONTINUITY_CURVATURE]: '曲线飞行，飞行器过点不停',
  [WaylineSmoothType.SMOOTH_OVER_POINTS]: '平滑过点，提前转弯'
}
export const BooleanEnum = {
  0: 'FALSE',
  1: 'TRUE',
  FALSE: 0,
  TRUE: 1
}

export const BtnCallBackLoading = { GO_CONTINUE: 'goContinue', EXECUTE_LOST_ACTION: 'executeLostAction' }
export const BtnLoading = {
  GO_BACK: 'goBack',
  HOVER: 'hover',
  LANDING: 'landing',
}
export const ExecuteRCLostActionType = {
  EXECUTE_LOST_ACTION: 'executeLostAction',
  GO_CONTINUE: 'goContinue'
}
export const FINISH_ACTION_TYPE = {
  AUTO_LAND: 'autoLand',
  GOTO_FIRST_WAYPOINT: 'gotoFirstWaypoint',
  GO_HOME: 'goHome',
  NO_ACTION: 'noAction'
}

export const FINISH_ACTION_TYPE_NAME = {
  [FINISH_ACTION_TYPE.GO_HOME]: '自动返航',
  [FINISH_ACTION_TYPE.GOTO_FIRST_WAYPOINT]: '返回航线起始点悬停',
  [FINISH_ACTION_TYPE.NO_ACTION]: '退出航线模式',
  [FINISH_ACTION_TYPE.AUTO_LAND]: '原地降落'
}
export const FollowType = {
  FIXED: 'fixed',
  FOLLOW_WAYLINE: 'followWayline',
  MANUALLY: 'manually',
  SMOOTH_TRANSITION: 'smoothTransition',
  TOWARD_POI: 'towardPOI'
}
export const FOLLOW_TYPE_NAME = {
  [FollowType.FIXED]: '锁定当前偏航角',
  [FollowType.FOLLOW_WAYLINE]: '沿航线方向',
  [FollowType.MANUALLY]: '手动控制',
}
export const GIMBAL_PITCH_MODE_TYPE = {
  MANUAL: 'manual',
  USE_POINT_SETTING: 'usePointSetting'
}
export const GIMBAL_PITCH_MODE_TYPE_NAME = {
  [GIMBAL_PITCH_MODE_TYPE.MANUAL]: '手动控制',
  [GIMBAL_PITCH_MODE_TYPE.USE_POINT_SETTING]: '依照每个航点控制'
}
export const FollowBadType = {
  CLOCKWISE: 'clockwise',
  COUNTER_CLOCKWISE: 'counterClockwise',
  FOLLOW_BAD_ARC: 'followBadArc',
}
export enum WaylineMapType{
  EGM96 = 'EGM96',
RELATIVE_TO_START_POINT = 'relativeToStartPoint',
ABOVE_GROUND_LEVEL = 'aboveGroundLevel',
REAL_TIME_FOLLOW_SURFACE = 'realTimeFollowSurface'
}

export const WaylineTypeMap = {
  REAL_TIME_FOLLOW_SURFACE: 'realTimeFollowSurface',
  RELATIVE_TO_START_POINT: 'relativeToStartPoint',
  WGS84: 'WGS84'
}
export const locationPosition = {
  0: 'MAIN',
  1: 'RIGHT',
  2: 'UP',
  MAIN: 0,
  RIGHT: 1,
  UP: 2
}

export const TEMPLATE_TYPE:{[x:number]:string} = {
  0: 'waypoint',
  1: 'mapping2d',
  2: 'mapping3d',
  3: 'mappingStrip',
}

export const FOCUS_MODE_TYPE:{[x:string]:string} = {
  CUSTOM: 'custom',
  FIRST_POINT: 'firstPoint'
}
export const METERING_MODE_TYPE:{[x:string]:string} = {
  AVERAGE: 'average',
  SPOT: 'spot'
}
export const RETURN_MODE_TYPE:{[x:string]:string} = {
  DUAL_RETURN: 'dualReturn',
  SINGLE_RETURN_FIRST: 'singleReturnFirst',
  TRIPLE_RETURN: 'tripleReturn'
}
export const SCANNING_MODE_TYPE:{[x:string]:string} = {
  NON_REPETITIVE: 'nonRepetitive',
  REPETITIVE: 'repetitive'
}
export const FLY_TO_WAYLINE_MODEL_TYPE = {
  POINT_TO_POINT: 'pointToPoint',
  SAFELY: 'safely'
}

export const SHOOT_TYPE:{[x:string]:string} = {
  DISTANCE: 'distance',
  TIME: 'time'
}
export const WaylineActionTypeName:{[x:string]:string} = {
  [WaylineActionType.TAKE_PHOTO]: '拍照',
  [WaylineActionType.PANOSHOT]: '全景拍照',
  [WaylineActionType.MultipleTiming]: '开始等时间隔拍照',
  [WaylineActionType.MultipleDistance]: '开始等距间隔拍照',
  [WaylineActionType.MultipleEnd]: '结束间隔拍照',
  [WaylineActionType.ZOOM]: '相机变焦',
  [WaylineActionType.START_RECORD]: '开始录像',
  [WaylineActionType.STOP_RECORD]: '停止录像',
  [WaylineActionType.START_AR_RECORD]: '定向录制',
  [WaylineActionType.STOP_AR_RECORD]: '停止录制',
  [WaylineActionType.GIMBAL_ROTATE_YAW]: '云台偏航角',
  [WaylineActionType.GIMBAL_ROTATE_PITCH]: '云台俯仰角',
  [WaylineActionType.HOVER]: '悬停',
  startMP20LightFlash: '开启警灯控制',
  stopMP20LightFlash: '关闭警灯控制',
  startSpeakerPlay: '开启喊话器控制',
  [WaylineActionType.START_AI]: '开启AI算法',
  [WaylineActionType.STOP_AI]: '关闭AI算法',
  [WaylineActionType.ROTATE_YAW]: '飞行器偏航角',
  [WaylineActionType.CUSTOM_DIRNAME]: '创建文件夹'
}

export const WaylineActionTypeIcon:{[x:string]:string} = {
  [WaylineActionType.TAKE_PHOTO]: 'icon-12paizhao-2',
  [WaylineActionType.PANOSHOT]: 'icon-a-360quanjing',
  [WaylineActionType.MultipleTiming]: 'icon-kaishidengshijiangepaizhao',
  [WaylineActionType.MultipleDistance]: 'icon-kaishidengjujiangepaizhao',
  [WaylineActionType.MultipleEnd]: 'icon-jieshujiangepaizhao',
  [WaylineActionType.ZOOM]: 'icon-bianjiao',
  [WaylineActionType.START_RECORD]: 'icon-luxiang',
  [WaylineActionType.STOP_RECORD]: 'icon-tingzhiluxiang',
  [WaylineActionType.START_AR_RECORD]: 'icon-luxiang1',
  [WaylineActionType.STOP_AR_RECORD]: 'icon-luxiangjieshu',
  [WaylineActionType.GIMBAL_ROTATE_YAW]: 'icon-yuntaipianhangjiao',
  [WaylineActionType.GIMBAL_ROTATE_PITCH]: 'icon-yuntaifuyangjiao',
  [WaylineActionType.HOVER]: 'icon-xuanting',
  startMP20LightFlash: 'icon-jinggaodeng',
  stopMP20LightFlash: 'icon-guanbijingdengkongzhi',
  startSpeakerPlay: 'icon-hanhua',
  [WaylineActionType.START_AI]: 'icon-AIsuanfa',
  [WaylineActionType.STOP_AI]: 'icon-shipin-guanbiAI',
  [WaylineActionType.ROTATE_YAW]: 'icon-feihangqipianhangjiao',
  [WaylineActionType.CUSTOM_DIRNAME]: 'icon-20gf-folderPlus'
}

export enum waylineFont {
  TTS='TTS',
  Audio='Audio'
}
